import { render, staticRenderFns } from "./VideoBoxes.vue?vue&type=template&id=482a4ed6"
import script from "./VideoBoxes.vue?vue&type=script&lang=js"
export * from "./VideoBoxes.vue?vue&type=script&lang=js"
import style0 from "./VideoBoxes.vue?vue&type=style&index=0&id=482a4ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports